import { render, staticRenderFns } from "./CmsScreenSettingsPopup.vue?vue&type=template&id=5e3effaf&scoped=true"
import script from "./CmsScreenSettingsPopup.vue?vue&type=script&lang=js"
export * from "./CmsScreenSettingsPopup.vue?vue&type=script&lang=js"
import style0 from "./CmsScreenSettingsPopup.vue?vue&type=style&index=0&id=5e3effaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3effaf",
  null
  
)

export default component.exports